// import { useState } from "react";
import Footer from "../../components/footer";
import Header from "../../components/header";
// import { isMobile } from "../../libs/userAgent";
import "./index.scss";
import { useAccount, useConnect, useContractRead, useContractWrite, useNetwork, usePrepareContractWrite, useSwitchNetwork } from "wagmi";
import { toast } from "react-toastify";
import { useEffect, useState } from "react";
import { BigNumber, ethers } from "ethers";
// import MerkleTreeComponent from "./MerkleTreeComponent";
import { MerkleTree } from 'merkletreejs';
import keccak256 from 'keccak256';
import treeData from '../../libs/tree.json';
// const root = treeData.root;
const leaves = treeData.leaves;
const Home = (): JSX.Element => {
  // const [showConnectWallet, setShowConnectWallet] = useState(false)

  const { connect, connectors, error, pendingConnector } =
    useConnect()
  const [claimedCount, setClaimecCount] = useState(0)

  const { isConnected, address } = useAccount()
  const { chain } = useNetwork()
  const { switchNetwork } =
    useSwitchNetwork()
  const [mintLoading, setMintLoading] = useState<boolean>(false)
  const [isWhitelist, setIsWhitelist] = useState<boolean>(true)
  const [isClaimed, setIsClaimed] = useState<boolean>(false)



  // const [proof, setProof] = useState<string | null>(null);
  // const [userAddress, setUserAddress] = useState<string>('');

  // (2) 计算 Merkle 树
  //@ts-ignore
  const merkleTree = new MerkleTree(leaves.map(ethers.utils.hexlify), keccak256, { sortPairs: true });

  // (3) 获取证明
  const getProofByAddressAndAmount = (address: any, amount: any) => {
    const leaf = ethers.utils.solidityKeccak256(['address', 'uint256'], [address, amount]);
    return merkleTree.getHexProof(leaf);
  };

  // const handleGenerateProof = (address: any) => {
  //   const amountPerAddress = ethers.utils.parseEther('10000');
  //   const proof = getProofByAddressAndAmount(address, amountPerAddress);
  //   return proof;
  // };
  const handleGenerateProof = (address: any): any => {
    const amountPerAddress = ethers.utils.parseEther('50000');
    if (address) {
      const proof = getProofByAddressAndAmount(address, amountPerAddress);
      if (proof) {
        return proof as readonly `0x${string}`[];
      }
    }
    return null;
  };

  // isClaim查询
  const { refetch: isClaimedFun } = useContractRead(
    {
      // @ts-ignore
      address: process.env.REACT_APP_CONTRACT_ADDRESS,
      abi: [
        {
          inputs: [
            {
              "internalType": "address",
              "name": "_claimer",
              "type": "address"
            }
          ],
          name: "isClaimed",
          outputs: [
            {
              "internalType": "bool",
              "name": "",
              "type": "bool"
            }
          ],
          stateMutability: "view",
          type: "function"
        },
      ],
      functionName: 'isClaimed',
      args: [address || '0x0000000'],
      // chainId: 421613,
      chainId: 42161,
      // enabled: Boolean(address),
      onSuccess(data: any) {
        setIsClaimed(data)
        // @ts-ignore
        // setCurrentEntryLens(parseInt(Number(data.entriesLength._hex), 10))
      },
      onError(error: any) {
        console.log('Error1212122211', error)
      },
    })

  // claim数量查询
  const { refetch: ClaimedCounrFun } = useContractRead(
    {
      // @ts-ignore
      address: process.env.REACT_APP_CONTRACT_ADDRESS,
      abi: [
        {

          inputs: [

          ],
          name: "getClaimedAddressCount",
          outputs: [
            {
              "internalType": "uint256",
              "name": "",
              "type": "uint256"
            }
          ],
          stateMutability: "view",
          type: "function"
        },
      ],
      functionName: 'getClaimedAddressCount',
      // args: [address || '0x0000000'],
      // chainId: 421613,
      chainId: 42161,
      // enabled: Boolean(address),
      onSuccess(data: any) {

        setClaimecCount(parseInt(data._hex, 16))
        // setIsClaimed(data)
        // @ts-ignore
        // setCurrentEntryLens(parseInt(Number(data.entriesLength._hex), 10))
      },
      onError(error: any) {
        console.log('Error1212122211', error)
      },
    })

  const {
    config,
    // error: prepareError,
    // isError: isPrepareError,
    // isSuccess: perSuccess
  } = usePrepareContractWrite({
    // @ts-ignore
    address: process.env.REACT_APP_CONTRACT_ADDRESS,
    abi: [
      {
        inputs: [
          {
            internalType: "uint256",
            name: "amount",
            type: "uint256"
          },
          {
            internalType: "bytes32[]",
            name: "merkleProof",
            type: "bytes32[]"
          }
        ],
        name: "claim",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function"
      }
    ],
    functionName: 'claim',
    args: [ethers.utils.parseEther('50000'), handleGenerateProof(address)],
    overrides: {
      from: address,
      // value: ethers.utils.parseEther(JSON.stringify(0)),
      gasLimit: BigNumber.from('3100000')
    },
    // chainId: 421613,
    chainId: 42161,
    // cacheTime: 2_000,
    // enabled: Boolean(address),
    // staleTime: 2_000,
    onSuccess(data: any) {
      console.log('Success', data)
    },
    onError(error: any) {

      console.log('Error1212122211', error.message)
    },
  })
  const {
    // data: mintNft, 
    // error, isError,
    write: enterWrite,
    isLoading
  } = useContractWrite({
    ...config,
    onSuccess(data: any) {
      setMintLoading(false)

      toast.success('Claim Success! Waiting for block confirmation.', {
        position: "top-right",
        autoClose: 5000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
        theme: "colored",
      })
    },
    onError(error: any) {
      toast.error(error.message, {
        position: "top-right",
        autoClose: 5000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
        theme: "colored",
      })
      setMintLoading(false)
    },
  })


  useEffect(() => {
    ClaimedCounrFun()
    if (address) {
      isClaimedFun()
    }
  })


  const mint = async () => {

    setMintLoading(true)

    // if (chain?.id !== 421613) {
    //   await switchNetwork?.(421613)
    // }
    if (chain?.id !== 42161) {
      await switchNetwork?.(42161)
    }
    // @ts-ignore
    if (handleGenerateProof(address).length <= 0) {
      setIsWhitelist(false)
      setMintLoading(false)
      return
    }

    await enterWrite?.()

    // setMintLoading(false)
  }



  return (
    <>
      {/* {
        showConnectWallet
          ? <ConnectWallet></ConnectWallet>
          : ''
      } */}
      <div className="page">
        <Header></Header>
        <div className="home" id="Home">
          <div className="banner">
            <h1
              className="title"
              data-aos="fade-in"
            >
              <img src={require('../../assets/banner-title.png').default} alt="" />
            </h1>
            <div className="about"
              data-aos="fade-up"
            >
              <h3>About Us</h3>
              <p>JustIntel (JIT) is a decentralized, trust-based social platform which allows users to connect effectively with projects and each other, while constructing comprehensive digital identities. The social connections are facilitated by on-chain data mining and big data algorithms. All the transaction data on JIT, including ratings, will be analyzed to generate valuable and actionable Web3 “Intels” which will be stored on-chain for permissionless accessibility.</p>
            </div>
          </div>
          {/* <div>
            <h1>Merkle Tree Proof Generator</h1>
            <MerkleTreeComponent />
          </div> */}
          <div className="airdrop" id="Airdrop">
            <div className="contain">
              <div
                className="text"
                data-aos="fade-right"
              >
                <h2><span>$</span>JIT Airdrop</h2>
                <p>Check your eligibility to  claim</p>
                <div className="progress-box">
                  <div className="progress">
                    <div className="count"
                      style={{
                        width: `${claimedCount / 1000 * 100}%`
                      }}
                    ></div>
                  </div>
                  <div className="num">
                    {claimedCount} / 1000
                  </div>
                </div>

                {
                  isConnected
                    ? <button
                      className="claim"
                      onClick={() => {
                        if (!isClaimed) {
                          mint()
                        }
                      }}
                    >
                      {

                        isClaimed ?
                          <span>Already claimed</span>
                          :

                          mintLoading
                            ? <div className={['absolute z-10 flex justify-center align-middle w-full h-full left-0 top-0 transition-all', mintLoading ? 'opacity-1' : 'opacity-0'].join(' ')}>
                              <img className="inline-block spinner-border animate-spin-slowing" src={require('../../assets/spinner-white.svg').default} alt="" width="30" height="30" />
                            </div>
                            :
                            <span>{isWhitelist ? 'claim' : <>You are not <br /> eligible to claim</>}</span>
                      }

                    </button>
                    : <>
                      {connectors.map((connector) => (
                        <button
                          disabled={!connector.ready}
                          key={connector.id}
                          className="claim"
                          onClick={() => connect({ connector })}
                        >
                          {/* {connector.name} */}
                          claim
                          {!connector.ready && ' (unsupported)'}
                          {isLoading &&
                            connector.id === pendingConnector?.id &&
                            ' (connecting)'}
                        </button>
                      ))}

                      {error && <div>{error.message}</div>}
                    </>
                }

              </div>
              <div
                className="pic"
                data-aos="fade-left"
              >
                <img src={require('../../assets/airgrop-pic.png').default} alt="" />
              </div>
            </div>
          </div>
          <div className="coupon">
            <h1
              className="blockTile"
              data-aos="fade-up"
            >JIT Coupon Utilities</h1>
            <div
              className="hotAir"
              data-aos="fade-in"
            >
              <img src={require('../../assets/hotAir.png').default} alt="" />
            </div>
            <div className="list">
              <div className="item" data-aos="fade-right" data-aos-delay="150">
                <div className="content">
                  <div className="num">
                    1.
                  </div>
                  <div className="text">
                    Priority access to special outfits in subsequent "Digital Soul" products.
                  </div>
                </div>
              </div>
              <div className="item" data-aos="fade-left" data-aos-delay="250">
                <div className="content">
                  <div className="num">
                    2.
                  </div>
                  <div className="text">
                    Free airdrops of parts of the "Digital Soul" outfits.
                  </div>
                </div>
              </div>
              <div className="item" data-aos="fade-right" data-aos-delay="350">
                <div className="content">
                  <div className="num">
                    3.
                  </div>
                  <div className="text">
                    Entitlement to anti-dilution airdrops each time the token inflates.
                  </div>
                </div>
              </div>
              <div className="item" data-aos="fade-left" data-aos-delay="450">
                <div className="content">
                  <div className="num">
                    4.
                  </div>
                  <div className="text">
                    When new features, services, or products are launched, coupon holders can have priority usage rights.
                  </div>
                </div>
              </div>
            </div>
            <div className="block">
              <div className="mission" data-aos="fade-right" data-aos-delay="200">
                <div className="title">
                  <div className="bg">
                  </div>
                  <div className="title-text">
                    Justintel
                  </div>

                </div>
                <div className="content">
                  <div className="subtitle">
                    <span>mission</span>
                  </div>
                  <p>At JustIntel, our vision is to become the beacon of trust in the trustless world of Decentralization, where individuals and communities can confidently engage and collaborate with complete peace of mind.
                  </p>
                </div>
                <div className="star">
                  <img src={require('../../assets/star.png').default} alt="" width={'100%'} />
                </div>
              </div>
              <div className="vision" data-aos="fade-left" data-aos-delay="300">
                <div className="title">
                  <div className="bg">
                  </div>
                  <div className="title-text">
                    Justintel
                  </div>

                </div>
                <div className="content">
                  <div className="subtitle">
                    <span>Vision</span>
                  </div>
                  <p>Our mission is to empower individuals and communities by providing the tools, knowledge, and decentralized platform necessary to navigate and thrive in the trustless landscape of Web3.
                  </p>
                </div>
                <div className="star" >
                  <img src={require('../../assets/star.png')} alt="" width={'100%'} />
                </div>
              </div>

              <div className="bgstar"  >
                <img data-aos="fade-in" data-aos-delay="400" src={require('../../assets/star.png').default} alt="" width={'100%'} />
              </div>
            </div>
          </div>
          <div className="JustIntel" id="Product">
            <h1 className="blockTile" data-aos="fade-up">JustIntel</h1>
            <p className="subtext" data-aos="fade-up" data-aos-delay="100">
              Trust-based Social Platform with Actionable
              INTELS
            </p>
            <div className="productlist">
              <div className="top">
                <div className="left" data-aos="fade-right">
                  <div className="text">
                    <h4 className="title">REAL UTILITIES</h4>

                    <h5 className="subtitle">Credibility Score: </h5>
                    <p>Calculated using machine learning algorithms based on user info and ratings.
                    </p>
                    <h5 className="subtitle">Social:  </h5>
                    <p>Enable messaging, comments, and interaction among friends.
                    </p>

                  </div>

                  <div className="img">
                    <img src={require('../../assets/product1.png').default} alt="" width={'100%'} />
                  </div>
                </div>
                <div className="right" data-aos="fade-left">
                  <div className="img">
                    <img src={require('../../assets/product1.png').default} alt="" width={'100%'} />
                  </div>
                  <div className="text">
                    <h4 className="title">REAL UTILITIES</h4>

                    <h5 className="subtitle">Credibility Score: </h5>
                    <p>Calculated using machine learning algorithms based on user info and ratings.
                    </p>
                    <h5 className="subtitle">Social:  </h5>
                    <p>Enable messaging, comments, and interaction among friends.
                    </p>

                  </div>
                </div>
              </div>
              <div className="center">
                <div className="list">
                  <div className="item item1" data-aos="fade-up">
                    <img src={require('../../assets/product3.png').default} alt="" width={'100%'} />
                  </div>
                  <div className="item item2" data-aos="fade-up">
                    <img src={require('../../assets/product4.png').default} alt="" width={'100%'} />
                  </div>
                  <div className="item" data-aos="fade-up">
                    <img src={require('../../assets/product5.png').default} alt="" width={'100%'} />
                  </div>
                </div>
              </div>
              <div className="bottom">
                <div className="text" data-aos="flip-right">
                  <h4 className="title">Robust Social Interactions</h4>
                  <p>JustIntel offers seamless access to information across channels, enabling users to express their views anytime, anywhere. Users can sync their actions with social platforms and actively participate in rating and commenting on others' credibility, fostering transparency and trust through meaningful interactions.</p>
                </div>
              </div>
            </div>
            <div className="digital">
              <div className="text" data-aos="zoom-in-right">
                Reinforcing Synergies among
                info, rating and digital soul
              </div>
              <div className="img" data-aos="zoom-in-left">
                <img src={require('../../assets/digital.png').default} alt="" width={'100%'} />
              </div>
            </div>
          </div>
          <div className="kol"
            data-aos="flip-left"
            data-aos-easing="ease-out-cubic"
            data-aos-duration="2000">
            <div className="quan"></div>
            <div className="img">
              <img src={require('../../assets/KOL.png').default} alt="" width={'100%'} />
            </div>
          </div>
          <div className="tokenomics" id="Tokenomics">
            <div className="jit"
              data-aos="zoom-in"
              data-aos-easing="ease-out-cubic"
              data-aos-duration="2000">
              {/* <div className="des">
                JIT Coupon is a novel element in JustIntel, offering exclusive utilities and limitless possibilities. With $JIT, our community gains access to specialized services, thrilling activities, and coveted privileges, setting us apart.It ignites community spirit, fuels engagement, and adds undeniable value to every member's journey.
              </div> */}
              <h4 className="title">JIT Tokenomics</h4>
              <p>TBD.Coming Soon!</p>
            </div>
            <div className="jit-title">
              <h2>JIT Coupononmics</h2>
              <p>JIT Coupon is not the official governance token of the project, <br /> which will be released after the launch of our official product</p>
            </div>
            <div className="chat">
              <div className="left"
                data-aos="fade-right"
                data-aos-easing="ease-out-cubic">
                <img src={require('../../assets/chat.png').default} alt="" />
              </div>
              <div className="right" data-aos="fade-left"
                data-aos-easing="ease-out-cubic">
                <div className="text">
                  <p>
                    JIT Coupon is a novel element within our project, bringing a range of unique utilities and possibilities to our community. These coupons will have various applications on our platform, including but not limited to obtaining specific services, participating in specific activities, and claiming exclusive privileges.
                  </p>
                  <br />
                  <p>
                    JIT Couponomics comprises an initial issuance of 20% of the total supply, with subsequent monthly airdrops and an extra 6% anti-dilution coupon for JIT coupon holders. The final distribution allocate coupons for rug victims (5%), community members (30%), ecosystem development (15%), team and early contributors (20%), treasury (20%), and advisors and partners (10%).
                  </p>
                  <br />
                  <p>
                    We believe that JIT Coupon will become an integral part of our community. They will enhance our community cohesion, stimulate our engagement, and bring more value to our members.
                  </p>
                </div>
              </div>
            </div>
          </div>
          <div className="roadmap">
            <div className="blockTile" data-aos="fade-up">Road Map</div>
            <div className="list">
              <div className="item item1" data-aos="fade-right" data-aos-delay=''>
                <h4>PRE-LAUNCH: BUILD COMMUNITY</h4>
                <p>We aim to create a vibrant and engaged community by fostering connections, providing valuable resources, and nurturing meaningful interactions, laying the foundation for shared success in our project.</p>
              </div>
              <div className="item item2" data-aos="fade-left">
                <h4>V1 PRODUCT RELEASE</h4>
                <p>Launch essential features including messaging, posting, and rating, enabling users to connect and engage. Additionally, personalized digital identities and a credibility system will be introduced, fostering transparency and individuality within our platform.</p>
              </div>
              <div className="item item3" data-aos="fade-right">
                <h4>V2 PRODUCT UPGRADE</h4>
                <p>Improve key functions by implementing a robust rating system, NFTizing personal accessories, integrating digital identities, expanding to other ecosystems, and creating sub-communities based on user interests. These enhancements will elevate user experience and foster a dynamic and engaging platform.</p>
              </div>
              <div className="item item4" data-aos="fade-left">
                <h4>V3 PRODUCT Commericialize</h4>
                <p>We will generate actionable insights applicable to social, credit evaluation, career, and investment domains. Additionally, we will collaborate with partners to develop tailored products utilizing our insights for mutual benefit.</p>
              </div>
            </div>
          </div>
          <div className="ecosystem">
            <div className="left" data-aos="zoom-in-right">
              <div className="blockTile">Ecosystem</div>
              <p>JustIntel’s products aim to produce utility for and build trust among users and institutions</p>
            </div>
            <div className="right" data-aos="zoom-in-left">
              <img src={require('../../assets/ecosystem.png').default} alt="" />
            </div>
          </div>

        </div>
        <Footer></Footer>
        <div className="bottom-quan">
          <div className="content"></div>
        </div>
      </div>
    </>
  );
}

export default Home;
